<template>
  <div>
    <div class="top-section">
      <div class="top-gradient"></div>
      <div class="scroll-down">
        Scroll Down
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="22px" viewBox="1793.669 1266.041 20 9.967" enable-background="new 1793.669 1266.041 20 9.967"
           xml:space="preserve">
          <g>
            <path fill="#1F1F1E" d="M1803.716,1276.008c-0.134,0-0.268,0-0.401-0.134l-9.366-8.562c-0.268-0.268-0.401-0.669-0.134-1.07
              c0.268-0.268,0.669-0.268,0.937,0l8.831,8.161l8.83-8.161c0.268-0.268,0.669-0.268,0.937,0c0.401,0.401,0.401,0.803,0.134,1.07
              l-9.365,8.562C1803.983,1275.874,1803.85,1276.008,1803.716,1276.008z"/>
          </g>
        </svg>
      </div>
    </div>
    <div class="scroll-spacing"></div>
    <page-sections :sections="page.fields.children.slice(0, 4)" />
    <div class="triangle-bg normal">
      <page-sections :sections="page.fields.children.slice(4)" />
    </div>
  </div>
</template>

<script>
import PageSections from '~/components/PageSections'
// import $ from 'jquery'

export default {
  components: {
    PageSections
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll)
    window.addEventListener("resize", this.handleScroll)

      // let headlines = document.querySelectorAll('section h3'), i
      // for (i = 0; i < headlines.length; ++i) {
      //   // headlines[i].style.display = 'none'
      //   // console.log(headlines[i])
      //   // console.log(headlines[i].innerHTML)
      //   let innerHTML = ''
      //   for (var i2 = 0; i2 < headlines[i].innerHTML.length; i2++) {
      //     headlines[i].style.opacity = 0
      //     let char = headlines[i].innerHTML.charAt(i2)
      //     innerHTML += '<span class="inline-block opacity-0 animated fadeInUp">'+char+'</span>'
      //   }
      //   headlines[i].innerHTML = innerHTML
      // }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleScroll)
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    // isElementVisible(el) {
    //   var rect     = el.getBoundingClientRect(),
    //       vWidth   = window.innerWidth || document.documentElement.clientWidth,
    //       vHeight  = window.innerHeight || document.documentElement.clientHeight,
    //       efp      = function (x, y) { return document.elementFromPoint(x, y) }     
    //   if (rect.right < 0 || rect.bottom < 0 
    //           || rect.left > vWidth || rect.top > vHeight)
    //       return false
    //   return (
    //         el.contains(efp(rect.left,  rect.top))
    //     ||  el.contains(efp(rect.right, rect.top))
    //     ||  el.contains(efp(rect.right, rect.bottom))
    //     ||  el.contains(efp(rect.left,  rect.bottom))
    //   )
    // },
    handleScroll() {
      let scrollY = window.scrollY
      const header = document.querySelector('header')
      const makeEveryMoment = document.querySelector('.make-every-moment')
      const forEveryFamily = document.querySelector('.for-every-family')
      const toDoTrySay = document.querySelector('.to-do-try-say')
      const getUpGoPlay = document.querySelector('.get-up-go-play')
      const heroImage = document.querySelector('.make-every-moment > picture img')
      const headingImage = document.querySelector('.make-every-moment h1 img')
      const scrollSpacing = document.querySelector('.scroll-spacing')

      // Animate headings if visible
      // let headlines = document.querySelectorAll('section h3'), i
      // for (i = 0; i < headlines.length; ++i) {
      //   // console.log(this.isElementVisible(headlines[i]))
      //   if (this.isElementVisible(headlines[i])) {
      //     let innerHTML = ''
      //     for (var i2 = 0; i2 < headlines[i].innerHTML.length; i2++) {
      //       headlines[i].style.opacity = 0
      //       let char = headlines[i].innerHTML.charAt(i2)
      //       innerHTML += '<span class="inline-block opacity-0 animated fadeInUp">'+char+'</span>'
      //     }
      //     headlines[i].innerHTML = innerHTML
      //   }
      // }

      // Scroll animations
      // Top 3 sections
      if (scrollY < 2100) {
        if (forEveryFamily.style.display = 'flex') {
          document.querySelector('.for-every-family .feature-slide-text img').style.transform = 'translateY('+(((scrollY-700)*.01)+7)+'px)'
          document.querySelector('.for-every-family .feature-slide-text').style.transform = 'translateY('+(((scrollY-700)*.01)+7)+'px)'
          document.querySelector('.for-every-family picture').style.transform = 'translateY('+(-((scrollY-700)*.01)+7)+'px)'
        }
        if (toDoTrySay.style.display = 'flex') {
          document.querySelector('.to-do-try-say .feature-slide-text img').style.transform = 'translateY('+(((scrollY-700)*.015))+'px)'
          document.querySelector('.to-do-try-say .feature-slide-text').style.transform = 'translateY('+(((scrollY-700)*.015))+'px)'
          document.querySelector('.to-do-try-say picture').style.transform = 'translateY('+(-((scrollY-700)*.015))+'px)'
        }
        if (getUpGoPlay.style.display = 'flex') {
          document.querySelector('.get-up-go-play .feature-slide-text img').style.transform = 'translateY('+(((scrollY-700)*.015)+10)+'px)'
          document.querySelector('.get-up-go-play .feature-slide-text').style.transform = 'translateY('+(((scrollY-700)*.015)+10)+'px)'
          document.querySelector('.get-up-go-play picture').style.transform = 'translateY('+(-((scrollY-700)*.015)+10)+'px)'
        }
      }


      // Scroll functions for larger display
      if (window.innerWidth >= 1024) {

        if (scrollY > 700) {
          forEveryFamily.style.display = 'none'
        }
        if (scrollY <= 700) {
          forEveryFamily.style.display = 'flex'
        }
        if (scrollY > 700) {
          toDoTrySay.style.display = 'flex'
        }
        if (scrollY <= 700 || scrollY >= 1400) {
          toDoTrySay.style.display = 'none'
        }
        if (scrollY >= 1400) {
          getUpGoPlay.style.display = 'flex'
        }
        if (scrollY > 2100 || scrollY < 1400) {
          getUpGoPlay.style.display = 'none'
        }
        // Scrolled past top 3 sections
        if (scrollY >= 2100) {
          heroImage.classList.add('animated')
          heroImage.classList.add('fadeIn')
          makeEveryMoment.style.display = 'flex'
          heroImage.style.width = (1045 + ((scrollY-2100)*.5))+'px'
          heroImage.style.height = 700+((scrollY-2100)*.45)+'px'
          headingImage.style.width = (776 + scrollY-2100) + 'px'
        } else {
          makeEveryMoment.style.display = 'none'
        }
        // Enable regular scrolling once make every moment section is 100% width and height
        if (makeEveryMoment.style.display == 'flex' && heroImage.offsetLeft < 1) {
          if (heroImage.getBoundingClientRect().top == 0) {
            makeEveryMoment.style.position = 'relative'
            if (makeEveryMoment.getBoundingClientRect().top > 0) {
              makeEveryMoment.style.marginTop = '-'+makeEveryMoment.getBoundingClientRect().top+'px'
            }
            document.querySelector('.scroll-down').style.display = 'none'
            document.querySelector('.top-section').style.opacity = '0'
            document.querySelector('.normal').style.opacity = '1'
            header.classList.add('opaque')
          }
        } else {
          document.querySelector('.top-section').style.opacity = '1'
          document.querySelector('.scroll-down').style.display = 'block'
          document.querySelector('.normal').style.opacity = '0'
          makeEveryMoment.style.position = 'fixed'
          makeEveryMoment.style.marginTop = '0'
          header.classList.remove('opaque')
        }
      }
    }
  },
  asyncData: async function({ $api }) {
    return {
      page: await $api.getPage('our-story'),
    }
  },
  head: function() {
    return {
      title: `${this.page.fields.title}`
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';

.our-story {
  background: url('https://images.ctfassets.net/3dar4x4x74wk/5DmXZ9p5DpsQqiw1iGLUUs/6e85dc8007c98c3101c936e4c30f5c76/triangle-bg.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;

  header.index.has-rte {
    @media (min-width: 1171px) {
      margin-top:-18px;
    }
  }

  header.index.opaque {
    margin-top:0px!important;
  }
  
  .normal {
    opacity: 0;

    section {
      margin-bottom: 80px;
      @media (max-width: 1023px) {
        margin-bottom: 50px;
      }
    }

    @media (max-width: 1023px) {
      opacity: 1!important;
    }
  }

  .top-section {
    background: url('https://images.ctfassets.net/3dar4x4x74wk/5DmXZ9p5DpsQqiw1iGLUUs/6e85dc8007c98c3101c936e4c30f5c76/triangle-bg.jpg');
    background-size: 100%;
    background-repeat: no-repeat;
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;

    @media (max-width: 1023px) {
      position: relative;
      height: auto;
    }

    &:before {
      content: '';
      width: 100vw;
      position: absolute;
      height: 600px;
      width: 100vw;
      left: 0;
      top: 0;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/1wtJeuTIY0eO2TlmUze4Xy/211b138525edc23f84179c99386b9cc2/splatter-purple.png');
      background-repeat: no-repeat;
      background-size: contain;
    }

    &:after {
      content: '';
      width: 100%;
      position: absolute;
      width: 100vh;
      height: 400px;
      right: 0;
      bottom: 0;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/2rsZOzx4C3t7ksFFXYWW0u/7d16433bb2086ddfbdf5b80c609c92a8/splatter-orange-right.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
    }

    .scroll-down {
      position: absolute;
      bottom: 15px;
      font-weight: 900;
      text-transform: uppercase;
      width: 100vw;
      text-align: center;
      font-size: 18px;

      svg {
        display: block;
        margin: 15px auto;
      }

      @media (max-width: 1023px) {
        display: none !important;
      }
    }
  }

  .scroll-spacing {
    height: 400vh;

    @media (max-width: 1023px) {
      display: none;
    }
  }

  .for-every-family {
    @media (max-width: 1023px) {
      padding-top: 100px!important;
    }  
  }

  .for-every-family, .to-do-try-say, .get-up-go-play {
    top: 0;
    min-height: 100vh;
    max-width: 100vw;
    display: flex;
    align-items: center;
    position: fixed;
    left: 50%;
    z-index: 1;
    width: 950px;
    margin: auto;
    padding-top: 20px;
    transform: translateX(-50%);

    @media (max-width: 1023px) {
      padding-bottom: 40px;
    }


    > picture img {
      width: auto;
      max-height: 73vh;
      @media (max-width: 1023px) {
        height: 450px;
        min-width: 400px;
      }
    }

    .feature-slide-text {
      align-items: center;
      width: 540px;
      position: absolute;
      bottom: 20vh;
      transform: translateX(-20px);
      height: 390px;
      display: flex;
      justify-content: center;

      @media (max-width: 1023px) {
        height: auto;
        position: relative;
        transform: translateX(0px);
        bottom: unset;
      }

      div {
        margin-bottom: 0;
        p:last-of-type {
          display: none;
        }
      }

      img {
        padding: 0;
        margin-top: 20px;
      }

      p {
        font-weight: bold;
        font-size: 36px;
        text-transform: uppercase;

        @media (max-width: $sm) {
          font-size: 27px;
        }
      }
    }

    @media (max-width: 1023px) {
      position: relative;
      min-height: auto;
      flex-wrap: wrap;
      justify-content: center;
      display: flex !important;

      .feature-slide-text {
        max-width: 100vw;
        bottom: unset !important;
      }
      
      > picture {
        margin: auto;
      }
    }

  }

  section {
    * {
      transition: all .2s;
    }
  }

  .feature-slide-text {

    @media (max-width: $md) {
      max-width: 93vw!important;
    }

    h3 {
      font-family: 'Dirty Brush';
      line-height: 1;
      margin-bottom: 18px;
      font-size: 50px;
      font-weight: 100;
    }

    p {
      margin: 0;
      font-weight: 500;
      max-width: 100%;
      margin-bottom: 18px;

      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }

  .to-do-try-say {
    display: none;
    width: 1150px!important;

    > picture {
      margin-left: auto;
    }

    .feature-slide-text {
      width: 631px!important;
      height: 320px!important;
      max-width: unset;
      left: 0;

      @media (max-width: 1023px) {
        height: auto !important;
      }


      p {
        max-width: unset;
      }

      img {
        position: absolute;
        bottom: 30px;
        right: -100px;
      }
    }
  }

  .get-up-go-play {
    display: none;

    @media (max-width: 1023px) {
      padding-bottom: 60px;
    }

    .feature-slide-text {
      width: 357px !important;
      bottom: 43vh;
      height: 315px !important;

      img {
        position: absolute;
        left: -85px;
        bottom: -7px;
      }
    }
  }

  .get-up-go-play, .to-do-try-say {
    .feature-slide-text {
      img {
        @media (max-width: 1023px) {
          display: none;
        }
      }
    }
  }

  .make-every-moment {
    min-height:100vh;
    position: fixed;
    top: 0;
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 1;

    @media (max-width: 1023px) {
      display: block!important;
      position: relative!important;
      min-height: auto;
      margin-top: 0!important;
      max-height: 100vh;
      height: 700px;
    }

    &:after {
      display: none;
    }

    > picture img {
      width: 1045px;
      height: 700px;
      object-fit: cover;
      max-height: 100vh;

      @media (max-width: 1023px) {
        height: 700px !important;
      }
    }

    h1 {
      display: flex;
      justify-content: center;
      width: 100vw;

      img {
        max-width: 900px;
        transform-origin: unset;
        width: 776px;
        transform: scale(1);

        @media (max-width: 1023px) {
          max-width: 85vw
        }

        @media (max-width: $sm) {
          max-width: 280px;
        }
      }
    }
  }

  .why-were-here {
    padding-top: 80px;
    @media (max-width: 1023px) {
      padding-top: 50px;
    }

    &:after {
      content: '';
      width: 100vw;
      position: absolute;
      height: 900px;
      width: 100vw;
      right: 0;
      top: -50px;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/5HyMM0O6pvKjhiFhPccc0Z/7185c53f712c1cde0e2833653ad409a6/splatter-orange-right-lg.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
      z-index: -1;

      @media (max-width: $md) {
        height: 250px;
        top: 50%;
      }
    }

    @media (max-width: 1236px) {
      .feature-slide-text {
        right: 0;
        left: unset !important;
      } 
    }
  }

  .why-were-here, .our-purpose, .section-food, .section-birthdays  {
    picture img {
      width: 760px;
      max-height: 730px;

      @media (max-width: 1023px) {
        margin: auto;
      }

      @media (max-width: 1023px) {
        object-position: top;
      }
    }

    picture {
      width: 1680px;
      max-width: 100vw;
      margin: auto;
      display: block;
    }

    > div {
      margin: auto;
      width: 1680px;
      max-width: 100vw;
    }

    .feature-slide-text {
      position: absolute;
      left: 660px;
      text-align: left;
      font-weight: 500;

      @media (max-width: 1023px) {
        right: 0;
        left: unset;
      }

      @media (max-width: 1023px) {
        position: relative;
        margin-top: -30px;
      }

      div {
        margin: 0;
      }

      h3 {
        font-family: 'Dirty Brush';
        background: $purple;
        position: absolute;
        top: -75px;
        left: 0;
        padding: 10px 14px 3px 14px;
        line-height: 1;
        font-size: 45px;
      }

      p {
        margin: 0;
        font-weight: 500;
        max-width: 100%;
        margin-bottom: 18px;

        &:last-of-type {
          margin-bottom: 0px;
        }
      }
    }
  }

  .our-purpose {
    .feature-slide-text {
      background: $orange url('../../assets/img/gradient-orange-pink-white.jpg') no-repeat;
      background-size: 100% 100%;
      right: 620px;
      left: unset;

      @media (max-width: 1197px) {
        right: unset;
        left: 0;
      }

      h3 {
        background: $pink;
      }
    }

    picture img {
      margin-left: auto;

      @media (max-width: 1023px) {
        margin: auto;
      }
    }
  }

  .section-birthdays {
    &:before {
      content: '';
      width: 100vw;
      position: absolute;
      height: 700px;
      width: 100vw;
      left: 0;
      bottom: 0;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/37lnepOiejBanxGXckoj4O/042ffc71cda9c9b0f816fa4b961071be/splatter-orange-left.png');
      background-repeat: no-repeat;
      background-size: contain;
      z-index: -1;
      @media (max-width: $md) {
        height: 250px;
      }
    }

    .feature-slide-text {
      max-width: 100vw;
      width: 644px;
      right: 620px;
      left: unset;

      @media (max-width: 1265px) {
        right: unset;
        left: 0;
      }
    }


    picture img {
      margin-left: auto;

      @media (max-width: 1023px) {
        // margin: auto;
        object-position: center;
      }
    }
  }

  .section-experiences {
    h3 {
      margin-bottom: 13px;
    }

    // .feature-slide-text {
    //   @media (max-width: 1023px) {
    //     margin-top: 80px;
    //   }
    // }
  }

  .section-food {

    &:after {
      content: '';
      width: 100vw;
      position: absolute;
      height: 800px;
      width: 100vw;
      right: 0;
      top: -50px;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/4CtL5YVQ9Y9zGo37dK6LI4/445bd90351d27fca17b04293541465e9/splatter-purple-right.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
      z-index: -1;

      @media (max-width: $md) {
        height: 250px;
        top: 50%;
      }
    }

    > picture img {
      @media (max-width: 1023px) {
        object-position: center;
      }
    }

    .feature-slide-text {
      position: absolute;
      left: 670px;
      max-width: 100vw;
      width: 634px;
      background: $orange url('../../assets/img/gradient-orange-pink-white.jpg') no-repeat;
      background-size: 100% 100%;

      @media (max-width: 1304px) {
        left: unset!important;
        right: 0;
      }


      @media (max-width: 1023px) {
        position: relative;
      }

      h3 {
        background: $pink;
      }
    }
  }

  .section-events {
    margin-bottom: 0!important;

    .feature-slide-text {
      left: 0;
      position: absolute;

      @media (max-width: 1023px) {
        // margin-top: 60px;
        left: unset;
        position: relative;
      }
    }
  }

  .section-links {
    margin-bottom: 0!important;
    &:before {
      content: '';
      width: 100vw;
      position: absolute;
      height: 550px;
      width: 100vw;
      left: 0;
      bottom: -130px;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/46bDGrMzCNUPJv4Lhbyzwq/0de71bd0d5b97369e844b9ddf5d55709/splatter-purple-bottom.png');
      background-repeat: no-repeat;
      background-size: contain;
      z-index: -1;
      @media (max-width: $md) {
        height: 250px;
      }
    }
    &:after {
      content: '';
      width: 100vw;
      position: absolute;
      height: 800px;
      width: 100vw;
      right: 0;
      top: -150px;
      background-image: url('https://images.ctfassets.net/3dar4x4x74wk/6rO0PGFCs3jZc4ods5Uz2C/9e0b17a341f321aafb23147358e48ef2/splatter-orange-top.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
      z-index: -1;

      @media (max-width: $md) {
        height: 250px;
        top: -75px;
      }
    }
    img {
      width: 850px;
      max-width: 90vw;
      margin: auto;
      object-fit: contain;
    }
  }
}
</style>